import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-print"
export default class extends Controller {

  // We are handling this as we want to download the PDF and close the modal (tricky to do in one single action server-side)
  submit(e) {
    
    // Prevent the form from submitting
    e.preventDefault()

    // First establish the form data
    const formData = new FormData(this.element)
    
    // Get the IDs string from the form data, situated at invoices[ids]
    const idString = formData.get("invoices[ids]")

    // Convert "1\n2\n3" to ["1", "2", "3"]
    const ids = idString.split("\n")
    
    // Convert the string to a resource string
    const resourceString = ids.map(id => `invoice_${id}`).join(",")
    
    // Create a new link element
    const link = document.createElement("a")
    
    // Set its attributes as a turbo stream link
    link.setAttribute("data-turbo-stream", "true")
    link.setAttribute("data-turbo-action", "advance")

    // Set the path to the PDF preview
    link.href = `/pdfs/preview?resources=${resourceString}&close_modal=true`

    // Append the link to the body
    document.body.appendChild(link)

    // Click the link
    link.click()
    
  }

}
